<map-info-window (closeclick)="closeClick()" [options]="options">
  <div class="tw:mt-2 tw:flex tw:justify-between">
    <red-walking-farm-property-lead-status-selector
      class="tw:block tw:w-40"
      [property]="property"
      [walkingFarmId]="walkingFarmId"
    >
    </red-walking-farm-property-lead-status-selector>
    <ion-button
      size="small"
      [routerLink]="[
        defaultBackHref,
        'walking-farm',
        walkingFarmId,
        'view',
        'property',
        property?.A000_PropertyNumber ?? ''
      ]"
    >
      Details<ion-icon slot="end" name="chevron-forward-circle-outline"></ion-icon>
    </ion-button>
  </div>
</map-info-window>
